/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import { useCallback } from "react";
import { getDownloadURL, ref } from 'firebase/storage';
import { cloud } from './firebase';
import { useEffect } from "react";







export function capitalize(input) {
    if (typeof input !== "string") {
        throw new TypeError("Input must be a string");
    }

    return input
        .split(" ") // Split the string into an array of words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
        .join(" "); // Join the array back into a string
}



export const useImageLoader = (callback=()=>{}, imgPath) => useEffect(() => {
    const getImage = async () => {
        if (!imgPath)   return;

        const storageRef = ref(cloud, imgPath);
        const url = await getDownloadURL(storageRef);
        callback(url);
    };

    getImage();
}, [callback, imgPath]);





export const isDesktop = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
    // Check for mobile devices
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
  
    return !isMobile; // Return true for desktop, false for mobile
};

  




